import { useParams } from "react-router-dom";
import { FieldBlock } from "@frontend/features/custom-fields/components/FieldBlock";
import { DynamicFieldsProvider } from "@frontend/features/support-forms/components/DynamicFieldsContext";
import { client } from "@frontend/features/common/services";
import { useSnackBar } from "@frontend/features/common/components/SnackBarContext";
import { useQueryClient } from "react-query";
import { useTranslation } from "react-i18next";
import { useGetCaseCustomFields } from "../../queries";
import { useDebounceFn } from '@frontend/features/common/hooks/useDebounceFn';

export const CaseCustomFields = () => {
  const { id } = useParams();
  const { t } = useTranslation();
  const {addToast} = useSnackBar();
  const queryClient = useQueryClient();
  const { data} = useGetCaseCustomFields({id});

  // Función base para actualizar un campo
  const updateField = async (fieldBlockId: string, fieldName: string, value: unknown) => {
    try {
      await client.put(`/case/${id}/custom-fields`, [{
        fieldBlockId,
        fieldName,
        value
      }]);
      
      addToast({
        message: t('cases.update.success'),
        color: 'success',
      });
      queryClient.invalidateQueries();
    } catch (_e) {
      addToast({
        message: t('cases.update.error'),
        color: 'error',
      });
    }
  };

  const debouncedUpdateField = useDebounceFn(updateField, 300);

  const handleFieldValueUpdate = (fieldBlockId: string) => (fieldName: string, value: unknown) => {
    debouncedUpdateField(fieldBlockId, fieldName, value);
  };

  return <>
    {data?.map(fb => (
      fb.fields && <DynamicFieldsProvider 
        key={fb.id}
        fields={fb.fields}
      >
        <FieldBlock title={fb.name} onUpdateField={handleFieldValueUpdate(fb.id)} />
      </DynamicFieldsProvider>
    ))}
  </>
}
